import { useAuth } from '../../hooks';
import { useAuthenticatedUser } from '../../api/user/useAuthenticatedUser';
import { User } from '../../models/user';

export const useAccountUser = () => {
  const { user: authUser } = useAuth();
  const { user: queriedUser, isLoading } = useAuthenticatedUser();
  // The query is the fresh record. Auth state covers the moment before it arrives.
  const signedInUser = authUser?.id ? authUser : undefined;
  const user = (queriedUser as User | undefined) ?? signedInUser;

  return {
    user,
    isLoading: Boolean(isLoading && !user),
  };
};
